import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { C08LinkListProps } from './C08LinkList';
import { LINK_LIST_ITEM_CONTAINER } from 'src/shared/static';
import { LinkListProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getDroplink } from 'src/shared/param-utils';

export function GetLinkListModel(props?: C08LinkListProps): LinkListProps {
  type t = LinkListProps;

  const { rendering, params, fields } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    headline: renderText(fields?.Title),
    supportingCopy: renderRichText(fields?.SupportingCopy),
    bottomCta: renderLink(fields?.BottomCTA),
    links: rendering && <Placeholder name={LINK_LIST_ITEM_CONTAINER} rendering={rendering} />,
    headlineAlignment: getDroplink<t['headlineAlignment']>(params?.TitleAlignment, 'left'),
    supportCopyAlignment: getDroplink<t['supportCopyAlignment']>(
      params?.SupportCopyAlignment,
      'left'
    ),
    ctaAlignment: getDroplink<t['ctaAlignment']>(params?.CTAAlignment, 'left'),
    headlineTag: getDroplink<t['headlineTag']>(params?.TitleType, 'p'),
    columnAlignment: getDroplink<t['columnAlignment']>(params?.ColumnAlignment, 'left'),
    backgroundColor: getDroplink<t['backgroundColor']>(params?.BackgroundTheme, 'white'),
    numColumns: getDroplink<t['numColumns']>(params?.NumberOfColumns, '2'),
    ctaStyle: getDroplink<t['ctaStyle']>(params?.CTAStyle, 'button'),
  };
}
